import { render, staticRenderFns } from "./MarketPrice.vue?vue&type=template&id=d01fd39e"
import script from "./MarketPrice.vue?vue&type=script&lang=js"
export * from "./MarketPrice.vue?vue&type=script&lang=js"
import style0 from "./MarketPrice.vue?vue&type=style&index=0&id=d01fd39e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports